export default __webpack_public_path__ + "static/media/Img0031.f5fc45ea.png";